export const paginate = (data, page, itemsPerPage, filter) => {

    if (data && data.length > 0) {

        var items = data;

        if (filter) {
            items = data.filter(i => i.mid.includes(filter));
        }

        var pageSize = itemsPerPage;
        var totalPages = Math.ceil(items.length / pageSize);

        if (page >= 1 || page <= totalPages) {
            var startIndex = (page - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, data.length - 1);
            var currentPageItems = items.slice(startIndex, endIndex + 1);
            return currentPageItems;
        }
    }
    return [];
}

export const pager = (data, page, itemsPerPage) => {

    if (data && data.length > 0) {
        var items = data;

        var pageSize = itemsPerPage;
        var totalPages = Math.ceil(items.length / pageSize);

        if (page >= 1 || page <= totalPages) {
            var startIndex = (page - 1) * pageSize;
            var endIndex = Math.min(startIndex + pageSize - 1, data.length - 1);
            var currentPageItems = items.slice(startIndex, endIndex + 1);

            
            return { totalPages: totalPages, items: currentPageItems };
        }
    } else {
        return { totalPages: 1, items: [] };
    }

}
